import { useNavigate } from "react-router-dom";
import { Brand, PoweredBy, Overline } from "@/components/Brand";
import { ScanLine, Store, ArrowRight } from "lucide-react";

const ROLES = [
  { key: "visitor", title: "Visitor Login", desc: "Discover exhibitors and plan your visits", icon: ScanLine, to: "/visitor/login" },
  { key: "exhibitor", title: "Exhibitor Login", desc: "Manage your stall, catalogues and leads", icon: Store, to: "/staff/login?role=exhibitor" },
];

export default function Landing() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex flex-col">
      <header className="max-w-md md:max-w-6xl mx-auto w-full px-4 h-16 md:h-20 flex items-center justify-between">
        <Brand />
        <span className="text-[11px]" style={{ color: "#264194" }}>Smartsevak</span>
      </header>

      <div className="max-w-md md:max-w-5xl mx-auto w-full px-4 pt-8 md:pt-16 fade-up">
        <Overline>JJS 2026 · 22–25 December</Overline>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-tight mt-3">
          <span className="gold-text">Engage.</span> <span className="text-slate-900">Connect.</span><br />
          <span className="text-slate-900">Convert.</span>
        </h1>
        <p className="text-slate-500 mt-4 max-w-md leading-relaxed">
          The connected experience for the JJS Jewellery Exhibition — discover stalls, scan, and build
          meaningful connections before, during and after the show.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-10">
          {ROLES.map((r, i) => (
            <button
              key={r.key}
              data-testid={`role-${r.key}`}
              onClick={() => navigate(r.to)}
              style={{ animationDelay: `${i * 80}ms` }}
              className="glass rounded-2xl p-6 text-left card-lift fade-up group"
            >
              <div className="flex items-start justify-between">
                <div className="h-12 w-12 rounded-xl btn-gold flex items-center justify-center gold-glow">
                  <r.icon size={22} className="text-[#26210F]" />
                </div>
                <ArrowRight size={18} className="text-slate-400 group-hover:text-[var(--jjs-gold-deep)] group-hover:translate-x-1 transition" />
              </div>
              <h3 className="font-serif-head text-2xl mt-4 text-slate-900">{r.title}</h3>
              <p className="text-sm text-slate-500 mt-1">{r.desc}</p>
            </button>
          ))}
        </div>

        <div className="mt-12 mb-8"><PoweredBy /></div>
      </div>
    </div>
  );
}
